import { getCategories } from "./categories";

export function logFixedCategories(): void {
	getCategories().then(items => {
		const typeid = [];
		const fixed = [];

		(items || []).forEach(item => {
			typeid.push(item.poiTypeId);
			fixed.push(item.fixed ? 1 : 0);
		});

		Mapy.getComponent("logger").log("fixed_suggestion_list", {
			typeid,
			fixed,
		});
	}, () => {});
}
